import styled from 'styled-components';

export const ResponsiveSearchDrawerItemContent = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  height: fit-content;

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    gap: 6px;
  }

  div:last-child {
    border-right: none;
  }
`;
